<!-- Backdrop -->
<div
  class="backdrop"
  [class.backdrop--visible]="open()"
  (click)="togglePanel(false)"
  aria-hidden="true"
></div>

<!-- Panel -->
<aside
  class="panel"
  [class.panel--open]="open()"
  role="dialog"
  aria-modal="true"
  aria-label="Kategorie"
>
  <div class="panel__header">
    <h3 class="m-0">{{name()}}</h3>
    <!-- <h3 style="border: 1px solid black; padding: 4px;">{{name()}}</h3> -->
    <button
      class="icon-btn"
      (click)="togglePanel(false)"
      aria-label="Zamknij panel"
    >
      &times;
    </button>
  </div>

  <div class="panel__content">
    @if (data().length > 0) { @for (root of data(); track root.id) {
    <ng-container
      *ngTemplateOutlet="
        nodeTpl;
        context: { $implicit: root, path: [], depth: 0 }
      "
    >
    </ng-container>
    } } @else {
    <p class="m-0 muted">Brak kategorii.</p>
    }
  </div>
</aside>

<ng-template #nodeTpl let-node let-path="path" let-depth="depth">
  <div class="cat">
    @if (!isLeaf(node)) {
    <button
      class="cat__btn"
      (click)="toggleNode(node.id)"
      [attr.aria-expanded]="isOpen(node.id)"
    >
      <span class="title" [class.title--root]="depth === 0">{{
        node.name
      }}</span>

      <div class="count-item-container">
        <div class="count-item-box parent">
          <span>{{ countItems(node) }}</span>
        </div>
        <span
          class="chev"
          [class.chev--open]="isOpen(node.id)"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24" class="chev__icon" focusable="false">
            <path d="M9 6 L15 12 L9 18" />
          </svg>
        </span>
      </div>
    </button>

    @if (isOpen(node.id)) {
    <div class="sub">
      @for (child of node.categories; track child.id) {
      <ng-container
        *ngTemplateOutlet="
          nodeTpl;
          context: {
            $implicit: child,
            path: nextPath(path, node.name),
            depth: depth + 1
          }
        "
      >
      </ng-container>
      }
    </div>
    } } @else {
    <button class="leaf__btn" (click)="onLeaf(node)">
      <span class="title" [class.title--root]="depth === 0">{{
        node.name
      }}</span>
      <div class="count-item-box child">
        <span>{{ countItems(node) }}</span>
      </div>
    </button>
    }
  </div>
</ng-template>
